import { Component } from '@angular/core';

@Component({
  selector: 'app-key-backup-light',
  templateUrl: './key-backup-light.component.html',
  styleUrls: ['./key-backup-light.component.scss']
})
export class KeyBackupLightComponent {

}
